import { styled } from '@mui/material/styles';
import { Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Paper, TablePagination, Divider, Typography, Stack } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Fragment, useState } from 'react';

import { DeleteTableField } from './DeleteTableField';
import '../styles/tableStyles.css';

/* ------PROPS------
    values: son los nombres de los campos de la tabla en la bbdd
    setFilterArray: función que modifica el filterArray del padre, que es el array que se muestra en la tabla (copia del array completo de los datos)
*/

export const TableBasic = ({ colNames, rows, values, tableTitle, setFilterArray, setCopyArray }) => {

    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [page, setPage] = useState(0);
    const [asc, setAsc] = useState(false);

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleClick = (i) => {    //ordenar columnas
        if (asc) {
            rows.sort(function (a, b) {
                if (a[values[i]] > b[values[i]]) { return -1; }
                if (a[values[i]] < b[values[i]]) { return 1; }
                return 0
            });
        } else {
            rows.sort(function (a, b) {
                if (a[values[i]] < b[values[i]]) { return -1; }
                if (a[values[i]] > b[values[i]]) { return 1; }
                return 0
            });
        }

        setAsc(!asc);
    }
    return (
        <Fragment>
            {rows.length === 0 ?
                (
                    <Stack width='100%'>
                        <Typography textAlign='center' mt='3rem' variant='h4'>No hay datos disponibles</Typography>
                    </Stack>
                )
                :
                (
                    <TableContainer component={Paper} mt={3}  >
                        <Table aria-label="customized table" >
                            <TableHead>
                                <TableRow>
                                    {/* compruebo que si estoy en el último o penúltimo, que lo alinee a la derecha 
                                    si no le gusta juntos, agregar esto
                                    || i === colNames.length - 2*/}
                                    {colNames.map((d, i) => {
                                        if (i === colNames.length - 1) {
                                            return <StyledTableCell align="right" key={d}>{d}</StyledTableCell>
                                        } else {
                                            return <StyledTableCell align='center' className='order' onClick={() => handleClick(i)} key={d}>{d} <ArrowDropDownIcon className='arrow' /> </StyledTableCell>
                                        }
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, i) => {
                                        return (
                                            <StyledTableRow key={i}>
                                                {Object.values(row).map((d, i) => (

                                                    (i !== 0) && <StyledTableCell align='center' key={i}>{d !== 'null' && d}</StyledTableCell>
                                                ))}
                                                <DeleteTableField setCopyArray={setCopyArray} rows={rows} setFilterArray={setFilterArray} tableTitle={tableTitle} keyDelete={row.id} />
                                            </StyledTableRow>)
                                    })}
                            </TableBody>
                        </Table>
                        <Divider />
                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={(a, page) => handleChangePage(page)}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            align='rigth'
                            labelDisplayedRows={()=> {return `${page+1} de ${Math.ceil(rows.length/rowsPerPage)}`}}
                        />
                    </TableContainer>
                )
            }
        </Fragment>
    )
}

//Estilos
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));